import { AuthErrorInterceptor } from '@cms_root/app/auth/totara/interceptors/auth-error.interceptor';
import { AuthHeadersInterceptor } from '../../auth/totara/interceptors/auth-headers.interceptor';
import { HeadersInterceptor } from '../base/interceptors/headers.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { TOTARA_HTTP_INTERCEPTORS } from './totara-http-interceptors.token';

export const interceptorProviders = [
  { provide: TOTARA_HTTP_INTERCEPTORS, useClass: AuthHeadersInterceptor, multi: true },
  { provide: TOTARA_HTTP_INTERCEPTORS, useClass: HeadersInterceptor, multi: true },
  { provide: TOTARA_HTTP_INTERCEPTORS, useClass: AuthErrorInterceptor, multi: true },
  { provide: TOTARA_HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }
];
